export default __webpack_public_path__ + "static/media/watercan.8090a61a.svg";